module.exports = __webpack_public_path__ + "static/media/galerija_2019 (17).1789f045.jpg";